<script lang="ts">
export default {
  name: 'ExportDropdown',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import DownloadButton from '@/components/v2/DownloadButton.vue';

defineProps<{
  exportType: string[];
  tooltip?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'export', type: string, finishExport: () => void): void;
}>();

const menuOpen = ref<boolean>(false);
const isExporting = ref<boolean>(false);

function handleExport(item: string) {
  isExporting.value = true;
  menuOpen.value = false;
  emit('export', item, () => (isExporting.value = false));
}

function toggleMenu() {
  menuOpen.value = !menuOpen.value;
}
</script>

<template>
  <div class="relative flex flex-col" ref="dropdownTrigger">
    <span v-if="isExporting" class="loading loading-dots loading-xs self-center"></span>
    <div v-else :class="{ 'tooltip tooltip-right': tooltip }" :data-tip="tooltip">
      <DownloadButton :disabled="disabled" @click="toggleMenu" />
    </div>

    <div
      v-if="menuOpen"
      class="menu menu-sm absolute bottom-auto top-[110%] z-90 flex w-max origin-top rounded-lg border border-solid border-gray-200 bg-base-100 shadow"
    >
      <ul>
        <li v-for="type in exportType" :key="type" class="px-1 py-1" @click="handleExport(type)">
          <span class="text-sm">Export as {{ type?.toUpperCase() }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
